import get from 'lodash/get'
import { required, lessThanOrEqualTo, moreThanOrEqualTo, isNumber } from '../../utils/validations'

const validate = (values: any) => ({
  loanAmount:
    isNumber(get(values, 'loanAmount')) ||
    required(get(values, 'loanAmount')) ||
    lessThanOrEqualTo(get(values, 'amountTo'))(get(values, 'loanAmount')) ||
    moreThanOrEqualTo(get(values, 'amountFrom'))(get(values, 'loanAmount')),
  term:
    required(get(values, 'term')) ||
    lessThanOrEqualTo(get(values, 'termTo'))(get(values, 'term')) ||
    moreThanOrEqualTo(get(values, 'termFrom'))(get(values, 'term')),
})

export default validate
